import { ISettingsType } from '../types';
import { onValue } from "firebase/database";
import { firebase } from '../config/firebase.client';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { EDIT_SETTINGS, FETCH_SETTINGS, CLEAR_SETTINGS_ERROR, FETCH_SETTINGS_SUCCESS, FETCH_SETTINGS_FAILED } from "../store/types";

export const fetchSettings = () => (dispatch: any) => {
  const { settingsRef } = firebase;

  dispatch({
    type: FETCH_SETTINGS,
    payload: null,
  });

  onValue(settingsRef, (snapshot) => {
    if (snapshot.val()) {
      dispatch({
        type: FETCH_SETTINGS_SUCCESS,
        payload: snapshot.val(),
      });
    } else {
      dispatch({
        type: FETCH_SETTINGS_FAILED,
        payload: "Unable to fetch database and settings.",
      });
    }
  });
};

export const editSettings = (settings: Partial<ISettingsType>) => async (dispatch: any) => {
  try {
    const functions = getFunctions();
    const editSettingsFn = httpsCallable(functions, 'settings-edit');

    const result = await editSettingsFn(settings);

    dispatch({
      type: EDIT_SETTINGS,
      payload: settings
    });

    return result.data;
  } catch (error: any) {
    console.error('Erro ao editar settings:', error);

    dispatch({
      type: FETCH_SETTINGS_FAILED,
      payload: error.message || 'Erro ao atualizar configurações'
    });

    throw error;
  }
};

export const clearSettingsViewError = () => (dispatch: any) => {
  dispatch({
    type: CLEAR_SETTINGS_ERROR,
    payload: null
  });
};